import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutHomeComponent } from '../layouts/components/layout-home/layout-home.component';
import { AllEventsHomeComponent } from './components/all-events-home/all-events-home.component';
import { EventDetailsComponent } from './components/event-details/event-details.component';
import { HomeComponent } from './home.component';
import { CgvComponent } from '../pages/legal/cgv/cgv.component';
import { PolitiqueConfidentialiteComponent } from '../pages/legal/politique-confidentialite/politique-confidentialite.component';
import { CguComponent } from '../pages/legal/cgu/cgu.component';
import { MentionsLegalesComponent } from '../pages/legal/mentions-legales/mentions-legales.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutHomeComponent,
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        path: 'home',
        component: HomeComponent,
      },
      {
        path: 'events',
        component: AllEventsHomeComponent,
      },
      {
        path: 'events/:id',
        component: EventDetailsComponent,
        data: { wtthoutHeader: true },
      },
      {
        path: 'politique-de-confidentialite',
        component: PolitiqueConfidentialiteComponent,
      },
      {
        path: 'conditions-generales-de-vente',
        component: CgvComponent,
      },
      {
        path: 'conditions-generales-d-utilisation',
        component: CguComponent,
      },
      {
        path: 'mentions-legales',
        component: MentionsLegalesComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class HomeRoutingModule {}
